import { Block } from '@aloft/toolkit-sui';

import { ToolkitPropertyTableUI } from '../ToolkitPropertyTable/ToolkitPropertyTableUI.tsx';
import { VacantLandSalesProperty } from './types.ts';
import { useVacantLandSalesTable } from './useVacantLandSalesTable.tsx';

export const VacantLandSalesTable = ({
  vacantLandSales,
  orderID,
  onRowClick,
  focusedRowIndex,
  rowsPerPage = 6,
}: {
  vacantLandSales: VacantLandSalesProperty[];
  orderID: string;
  onRowClick: (row: VacantLandSalesProperty) => void;
  focusedRowIndex: number;
  rowsPerPage?: number;
}) => {
  const { table } = useVacantLandSalesTable(vacantLandSales, orderID, rowsPerPage);

  return (
    <Block flex={1} width="100%">
      <ToolkitPropertyTableUI
        table={table}
        shouldPinFirstRow={false}
        onRowClick={onRowClick}
        activeRowIndex={focusedRowIndex}
        useVirtualization={false}
      />
    </Block>
  );
};
